import type { ReactNode, TableHTMLAttributes } from 'react';

import styles from './Table.module.css';

interface TableProps extends TableHTMLAttributes<HTMLTableElement> {
  children: ReactNode;
}

// Оформленная таблица в скроллируемом контейнере со скруглением и shadow-card.
export function Table({ className, children, ...rest }: TableProps): JSX.Element {
  return (
    <div className={styles.wrap}>
      <table className={[styles.table, className].filter(Boolean).join(' ')} {...rest}>
        {children}
      </table>
    </div>
  );
}
